import { useEffect, useState } from 'react';
import type { MainLoaderData } from '@/root';

import packageJson from '../../../package.json';
import { HEAP_APP_ID_MAP } from '@/api/heap/heap.constants';

const appVersion: string = packageJson.version;

export function HeapScript({
  userId,
  env,
}: {
  userId?: MainLoaderData['userId'];
  env?: MainLoaderData['ENV'];
}) {
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  useEffect(() => {
    if (isScriptLoaded || !userId || !env) {
      return;
    }
    if (typeof window !== 'undefined') {
      window.heap = window.heap || [];
      window.heap.load = function (e: string, t?: Record<string, unknown>) {
        window.heap.appid = e;
        window.heap.config = t = t || {};
        const r = document.createElement('script');
        r.type = 'text/javascript';
        r.async = !0;
        r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js';
        const a = document.getElementsByTagName('script')[0];
        a?.parentNode?.insertBefore(r, a);
        for (
          let n = function (e: string) {
              return function () {
                window.heap?.push?.(
                  // eslint-disable-next-line prefer-rest-params
                  [e].concat(Array.prototype.slice.call(arguments, 0)),
                );
              };
            },
            p = [
              'addEventProperties',
              'addUserProperties',
              'clearEventProperties',
              'identify',
              'resetIdentity',
              'removeEventProperty',
              'setEventProperties',
              'track',
              'unsetEventProperty',
            ],
            o = 0;
          o < p.length;
          o++
        ) {
          // @ts-expect-error-next-line
          window.heap[p[o]] = n(p[o]);
        }
      };
      window.heap.load(HEAP_APP_ID_MAP[env.NODE_ENV]);
      window.heap.identify(userId);
      window.heap.addEventProperties({
        app_name: 'scanme_aura_com',
        app_version: appVersion,
        env: env.NODE_ENV,
        user_id: userId,
      });
      setScriptLoaded(true);
    }
  }, [userId, env, isScriptLoaded]);

  return null;
}
